import React from 'react';

import {NavLink} from './components';

import * as styles from './PageNav.module.css';

export function PageNav({links}) {
  return (
    <nav className={styles.Nav}>
      {links.map(({url, content}, index) => (
        <NavLink key={index} to={url}>
          {content}
        </NavLink>
      ))}
    </nav>
  );
}
